import { useMemo } from "react";
import { createUseStyles } from "react-jss";
import Badge from "$components/Badge";

type Props = {
  askedQty: number;
  availableQty: number;
};
function AskedQtyBadge({ askedQty, availableQty }: Props) {
  const classes = useStyles();
  const badgeStockColor = useMemo(() => {
    if (availableQty < askedQty) return "red";
    return "green";
  }, [availableQty, askedQty]);

  return (
    <Badge color={badgeStockColor} className={classes.badgeAvailable}>
      {availableQty}
    </Badge>
  );
}

export default AskedQtyBadge;

const useStyles = createUseStyles(() => ({
  badgeAvailable: {
    alignItems: "center",
    borderRadius: "25px !important",
    fontSize: "15px",
    padding: "5px 10px !important",
  },
}));
